import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "iodine-references-header" }
const _hoisted_2 = { class: "references-option" }
const _hoisted_3 = { class: "references-search-bar" }

import { onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { TitledObject } from 'src/services/TrucodeReferencesService';
import { useTrucodeReferenceStore } from 'stores/references-store';
import DropDown from 'components/global-common/DropDown.vue';
import SearchBar from 'components/global-common/SearchBar.vue';
import {useGrouperStore} from 'stores/grouper-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesHeader',
  setup(__props) {

const bookReferences = ref<TitledObject[]>([]);
const searchBarRef = ref<InstanceType<typeof SearchBar> | null>(null);
const { readOnly } = storeToRefs(useGrouperStore());

const referencesStore = useTrucodeReferenceStore();
const { mode, currentTerm, currentSearchBook, currentBrowseBook } = storeToRefs(referencesStore);

onMounted(async () => {
  const result = await referencesStore.getSearchBookReference();
  bookReferences.value = result;
});

function bookChanged(referencesBook: TitledObject, search: boolean) {

  if (search) {
    referencesStore.setCurrentSearchBook(referencesBook);
    searchBarRef.value?.search();
  } else {
    referencesStore.setCurrentBrowseBook(referencesBook);
  }
}

async function referencesOptionChanged(value: 'search'|'browse') {

  mode.value = value;

  if (value == 'search') {
    bookReferences.value = await referencesStore.getSearchBookReference() || [];
  } else {
    bookReferences.value = await referencesStore.getBrowseBookReference() || [];
  }

}

function searchChanged(text: string): Promise<object[]> {

    return referencesStore.getReferenceBookTermSearch('' + text);
}


return (_ctx: any,_cache: any) => {
  const _component_q_radio = _resolveComponent("q-radio")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_radio, {
        modelValue: _unref(mode),
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => (_isRef(mode) ? (mode).value = $event : null)),
          referencesOptionChanged
        ],
        val: "search",
        label: "Search"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_q_radio, {
        modelValue: _unref(mode),
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => (_isRef(mode) ? (mode).value = $event : null)),
          referencesOptionChanged
        ],
        val: "browse",
        label: "Browse"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createVNode(DropDown, {
        modelValue: _unref(currentSearchBook),
        "onUpdate:modelValue": [
          _cache[2] || (_cache[2] = ($event: any) => (_isRef(currentSearchBook) ? (currentSearchBook).value = $event : null)),
          _cache[3] || (_cache[3] = (option) => bookChanged(option as TitledObject, true))
        ],
        options: bookReferences.value,
        "option-label": "title",
        "option-value": "id",
        label: "Book",
        disabled: _unref(readOnly),
        "iodine-class-name": "references-book"
      }, null, 8, ["modelValue", "options", "disabled"]), [
        [_vShow, _unref(mode) === 'search']
      ]),
      _withDirectives(_createVNode(DropDown, {
        modelValue: _unref(currentBrowseBook),
        "onUpdate:modelValue": [
          _cache[4] || (_cache[4] = ($event: any) => (_isRef(currentBrowseBook) ? (currentBrowseBook).value = $event : null)),
          _cache[5] || (_cache[5] = (option) => bookChanged(option as TitledObject, false))
        ],
        options: bookReferences.value,
        "option-label": "title",
        "option-value": "id",
        label: "Book",
        disabled: _unref(readOnly),
        "iodine-class-name": "references-book"
      }, null, 8, ["modelValue", "options", "disabled"]), [
        [_vShow, _unref(mode) === 'browse']
      ]),
      _createVNode(SearchBar, {
        search: searchChanged,
        modelValue: _unref(currentTerm),
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(currentTerm) ? (currentTerm).value = $event : null)),
        "class-name": "references",
        ref_key: "searchBarRef",
        ref: searchBarRef,
        "show-results-menu": false,
        "should-rerender": false,
        disable: _unref(mode) !== 'search' || !_unref(currentSearchBook) || _unref(readOnly)
      }, null, 8, ["modelValue", "disable"])
    ])
  ]))
}
}

})